import { render } from "./ChatWidget.vue?vue&type=template&id=31a1dc0d&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"

import "./ChatWidget.vue?vue&type=style&index=0&id=31a1dc0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a1dc0d"]])

export default __exports__